<template>
  <footer class="statsheet-unlocked-footer">
    <div class="footer-content" v-if="!showReject">
      <h2 class="footer-title">
        <i class="mdi mdi-lock-open-outline"></i>
        Welcome to Teamwrkr!
      </h2>
      <p class="footer-desc">
        This is your <strong>publicly viewable</strong> AI generated profile. Please review and choose to approve or reject below.
      </p>
      <div class="footer-actions">
        <b-button type="is-primary" @click="lockStatsheet" :loading="loading">
          Looks great, lock my Profile!
        </b-button>
        <!-- <b-button
          type="is-secondary"
          @click="showReject = true"
        >
          Reject my Profile
        </b-button> -->
         <b-button
            type="is-secondary"
            tag="a"
            href="/reject-profile"
            target="_blank"
            rel="noopener"
          >
            Reject my Profile
          </b-button>
      </div>
    </div>
    <div class="footer-content" v-else>
      <h2 class="footer-title">
        <i class="mdi mdi-emoticon-sad-outline"></i>
        Oh No!
      </h2>
      <div v-if="!feedbackSubmitted">
        <p class="footer-desc">
          Please leave us some feedback on what you don't like about your Profile.
        </p>
        <b-input
          v-model="feedback"
          type="textarea"
          placeholder="Your feedback..."
          rows="4"
        ></b-input>
        <div class="footer-actions">
          <b-button type="is-primary" @click="submitFeedback" :loading="loading">
            Submit Feedback
          </b-button>
          <b-button type="is-secondary" @click="showReject = false">
            Back
          </b-button>
        </div>
      </div>
      <div v-else>
        <p class="footer-desc">
          Thank you for your feedback! We'll use it to improve your Profile and the Teamwrkr platform. Someone will be in touch soon.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'

export default {
  name: 'StatsheetUnlocked',
  data() {
    return {
      showReject: false,
      feedback: '',
      feedbackSubmitted: false,
      config: {
        headers: { 'Authorization': this.$cookies.get('teamwrkr-token') }
      }
    };
  },
  computed: {
    // Pull reactive state directly from Pinia
    ...mapState(useUserStore, ['user', 'loading']),
    isLoading() {
      return this.loading || !this.user
    },
  },

  created() {
    console.log('Reactive user in statsheet locked .vue:', this.user);
  },
  methods: {
    async lockStatsheet() {
      console.log('Locking statsheet for user:', this.user._id, this.config);
      const userStore = useUserStore()
      // this.loading = true;
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/lock-statsheet`,
          {},
          this.config
        );

        const updatedUser = response.data;

        userStore.setUser(updatedUser)
      } catch (error) {
        console.error('Error locking statsheet:', error);
      } finally {
        // this.loading = false;
        this.$router.push('/');
      }
    },
    async submitFeedback() {
      this.loading = true;
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL}/feedback`,
          {
            area: 'Profile Rejection',
            message: this.feedback,
            user: this.user?._id,
          },
          this.config
        );
        this.feedbackSubmitted = true;
        this.feedback = '';
      } catch (error) {
        console.error('Error submitting feedback:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.statsheet-unlocked-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: $color-surface;
  box-shadow: 0 -2px 16px rgba(170, 118, 214, 0.10);
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-content {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.footer-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: $color-primary;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 0.2rem;
  i {
    color: $color-warning;
    font-size: 1.7rem;
  }
}

.footer-desc {
  font-size: 1.05rem;
  color: $color-text-muted;
  margin-bottom: 0.5rem;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

@media screen and (max-width: 900px) {
  .statsheet-unlocked-footer {
    padding: 1.2rem 0.5rem 0.7rem 0.5rem;
    border-radius: 0.7rem 0.7rem 0 0;
  }
  .footer-content {
    max-width: 100%;
    gap: 0.8rem;
  }
  .footer-title {
    font-size: 1.1rem;
    i {
      font-size: 1.3rem;
    }
  }
  .footer-desc {
    font-size: 0.98rem;
  }
}
</style>
